<template>
  <!-- Navbar -->
  <nav
    class="w-full z-20 flex items-center px-3 py-2 xl:p-3 bg-blue-500 h-14 xl:h-20 transition-all select-none"
  >
    <div
      class="w-full mx-auto items-center flex justify-between px-1 xl:px-2"
    >
      <div class="flex flex-row space-x-2 xl:space-x-4 items-center">
        <!-- 모바일 햄버거 메뉴 버튼 (xl 이상에서는 숨김) -->
        <button
          type="button"
          @click="$emit('toggle-sidebar')"
          class="xl:hidden flex items-center justify-center w-9 h-9 text-white hover:bg-blue-600 rounded-lg focus:outline-none transition-colors mr-1"
          aria-label="메뉴 열기"
        >
          <i class="fa-solid fa-bars text-xl"></i>
        </button>

        <!-- 로고 아이콘 (모바일 숨김, PC에서만 표시) -->
        <img
          src="@/assets/img/swci.png"
          class="hidden xl:block xl:w-12 xl:h-12 rounded-lg object-contain"
        />
        <!-- Brand -->
        <router-link
          class="text-left pb-0 text-white"
          to="/scm/home"
        >
          <div class="text-base sm:text-lg xl:text-2xl font-bold tracking-tight leading-tight">
            삼우강업㈜ 영업관리 지원시스템
          </div>
          <div class="hidden xl:block text-xs xl:text-base opacity-90 leading-tight">
            SAMWOO Sales Management Support System
          </div>
        </router-link>
      </div>

      <!-- User (모바일일 때는 숨김, PC에서만 표시) -->
      <ul class="hidden xl:flex items-center">
        <user-dropdown />
      </ul>
    </div>
  </nav>
  <!-- End Navbar -->
</template>

<script setup>
import { defineEmits } from "vue";
import UserDropdown from "@/components/layouts/UserDropdown.vue";

defineEmits(["toggle-sidebar"]);
</script>
